import chunk from 'lodash/chunk';

import { projectsStardogRequestDispatchers } from 'src/actions/projects/actionCreators';
import { PROJECT_MODEL_LABEL_LIMIT } from 'src/constants/limits';
import { projectModelsByIdSelector } from 'src/selectors/projectModelsById';
import { Connection } from 'src/store/connections/types';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';

export const requestProjectModelLabelsAndDescriptions =
  ({
    projectId,
    modelId,
    connection,
    databaseId,
    namedGraphs,
    allIris,
  }: {
    projectId: string;
    modelId: string;
    connection: Connection;
    databaseId: string;
    namedGraphs: string[];
    allIris: Set<string>;
  }) =>
  async (_dispatch: AppDispatch, getState: ReduxStateGetter) => {
    const existingLabels = new Set(
      Object.keys(
        projectModelsByIdSelector(projectId)(getState()).labelsByIri || {}
      )
    );
    const missingLabels = Array.from(allIris).filter(
      (iri) => !existingLabels.has(iri)
    );

    if (missingLabels.length) {
      const chunks = chunk(missingLabels, PROJECT_MODEL_LABEL_LIMIT);
      await Promise.all(
        chunks.map((iris) =>
          projectsStardogRequestDispatchers.requestProjectModelLabelsAndDescriptions(
            {
              id: projectId,
              modelId,
              connection,
              databaseId,
              namedGraphs,
              iris,
            }
          )
        )
      );
    }
  };
